<template>
  <v-card
    class="mx-auto overflow-visible"
    width="800px"
    style="margin-top: 0px; margin-bottom: 0px;"
    outlined
  >
    <v-list-item three-line>
      <validation-observer v-slot="{ handleSubmit }">
        <v-list-item-content class="overflow-visible">
          <v-row class="align-center">
            <v-col cols="10">
              <v-list-item-title class="headline mb-2">Tìm kiếm nâng cao</v-list-item-title>
            </v-col>
            <v-col cols="2" class="text-right">
              <v-icon aria-label="Close" @click="closeMenu">mdi-close</v-icon>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field placeholder="Nhập mã đơn hàng" v-model="filterForm.code" label="Mã đơn hàng" clearable />
            </v-col>
<!--            <v-col cols="12" md="4">-->
<!--              <v-autocomplete-->
<!--                  v-model="filterForm.ministryIds"-->
<!--                  :items="ministries"-->
<!--                  item-text="name"-->
<!--                  item-value="id"-->
<!--                  label="Bộ phận"-->
<!--                  placeholder="Chọn bộ phận"-->
<!--                  @change="onChangeMinistry"-->
<!--                  multiple-->
<!--                  class="selectAll-group-product"-->
<!--                  clearable-->
<!--              >-->
<!--                <template #prepend-item>-->
<!--                  <common-select-all-->
<!--                      v-model="filterForm.ministryIds"-->
<!--                      :item="filterForm.ministryIds"-->
<!--                      :items="ministries.map(s => s.id)"-->
<!--                  ></common-select-all>-->
<!--                </template>-->
<!--              </v-autocomplete>-->

<!--            </v-col>-->
            <v-col cols="12" md="4">
              <common-select-user
                class="btn-style-all"
                v-model="filterForm.userIds"
                :items="usersAgency"
                color="primary"
                item-text="fullName"
                item-value="id"
                placeholder="Nhân viên kinh doanh"
                label="Nhân viên kinh doanh"
                multiple
                clearable
              />
              <template #prepend-item>
                <common-select-all
                    v-model="filterForm.userIds"
                    :item="filterForm.userIds"
                    :items="usersAgency.map(s => s.id)"
                ></common-select-all>
              </template>
            </v-col>
            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="filterForm.productId"
                :items="products"
                item-text="name"
                item-value="id"
                label="Sản phẩm"
                placeholder="Chọn sản phẩm"
                clearable
              />
            </v-col>
            <v-col cols="12" md="4">
              <common-range-picker
                :clearable="true"
                :aLight="'center'"
                label="Ngày tạo đơn"
                v-model="filterForm.createdAt"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="filterForm.statusIds"
                :items="filterAgencyStatusList"
                item-text="name"
                item-value="id"
                label="Trạng thái đơn"
                placeholder="Chọn trạng thái đơn"
                clearable
                multiple
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="filterForm.paymentType"
                :items="paymentTypes"
                label="Phương thức thanh toán"
                placeholder="Chọn phương thức thanh toán"
                clearable
              />
            </v-col>
            <v-row v-if="!$route.params.id">
              <v-col cols="12" md="6">
                <v-text-field placeholder="Nhập tên đại lý" v-model="filterForm.agencyName" label="Tên đại lý" clearable />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  placeholder="Nhập số điện thoại đại lý"
                  v-model="filterForm.agencyPhone"
                  label="Số điện thoại đại lý"
                  clearable
                />
              </v-col>
              <!-- <v-col cols="12" md="4">
                <v-autocomplete
                  v-model="filterForm.tinhName"
                  :items="provinces"
                  item-text="ten"
                  label="Tỉnh thành"
                  placeholder="Chọn tỉnh thành"
                  clearable
                />
              </v-col> -->
            </v-row>
          </v-row>
          <div class="d-flex text-center mb-4 justify-center">
            <v-btn class="primary mx-0" @click.prevent="handleSubmit(searchOrder)">
              <v-icon>mdi-dropdown</v-icon>Tìm kiếm
            </v-btn>
            <div  class="d-flex ml-5 group-input">
              <v-btn
                class="primary mx-0 download"
                v-if="checkAuthorization('agency-admin_download')"
                @click.prevent="handleSubmit(exportExcel)"
              >
                <v-icon>mdi-download</v-icon>Download
              </v-btn>
            </div>
          </div>
        </v-list-item-content>
      </validation-observer>
    </v-list-item>
  </v-card>
</template>

<style>
.download {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
}

.dropdown {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
  min-width: 35px !important;
  width: 30px;
  position: absolute;
  right: -30px;
}
</style>


<script>
import TokenService from '../../../helpers/token';
import RepositoryFactory from '../../../repositories/RepositoryFactory';
import { downloadFile } from '../../../helpers/utils';
import AgencyRepository from "../../../repositories/AgencyRepository";
const ProductRepository = RepositoryFactory.get('product');
const AddressRepository = RepositoryFactory.get('address');
export default {
  props: {
    filterAgencyStatusList: {
      type: Array,
      default: () => ([])
    },
    // id: {
    //   type: [String, Number],
    // },
    usersAgency: {
      type: Array,
      default: () => ([])
    },
    openMenu: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      users: [],
      ministries: [],
      productGroups: [],
      products: [],
      agencySources: [],
      paymentTypes: ['COD', 'BANK'],
      // itemsExport: [
      //     { title: 'Đối soát', code: 'DOISOAT' },
      //     { title: 'Kế toán', code: 'KETOAN' },
      // ],
      listUsers: [],
      filterForm: {
        keyword: '',
        code: '',
        // ministryIds: [],
        userIds: [],
        groupId: '',
        productId: '',
        paymentType: '',
        createdAt: [],
        statusIds: []
      },
      provinces: []
    };
  },
  computed: {

  },
  async created() {
    if (this.$route.params.id) {
      this.filterForm.agencyId = this.$route.params.id;
    } else {
      this.filterForm.agencyName = ''
      this.filterForm.agencyPhone = ''
    }
    const loader = this.$loading.show();
    await Promise.all([
      this.getProducts()
    ]);
    loader.hide();

    this.getProvinces()
  },

  beforeDestroy() {

  },
  methods: {
    // ds tinh/thanh
    async getProvinces() {
      const respond = await AddressRepository.provinces({ limit: 100 });
      if (_.get(respond, 'success', false)) {
        this.provinces = _.get(respond, 'data', []).filter(
          data => data.id != 0
        );
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(respond, 'message', '')
        });
      }
    },
    closeMenu() {
      Bus.$emit('close-filter-form-agency')
    },
    async getProducts() {
      const respond = await ProductRepository.listAll({ limit: 100, moduleType: 10 });
      if (_.get(respond, 'success', false)) {
        const products = _.get(respond, 'data.products', []).map(product => {
          const productTemp = product;
          // productTemp.idTemp = `product-${product.id}`;
          return productTemp;
        });
        const combos = _.get(respond, 'data.combos', []).map(combo => {
          const comboTemp = combo;
          // comboTemp.idTemp = `combo-${combo.id}`;
          comboTemp.price = _.get(comboTemp, 'products', []).reduce(
            (accumulator, product) => {
              return accumulator + _.get(product, 'price', 0);
            },
            0
          );
          return comboTemp;
        });
        this.products = [
          { header: 'Sản Phẩm' },
          ...products
        ];
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(respond, 'message', '')
        });
      }
    },
    searchOrder() {
      let self = this
      if (self.filterForm.code !== '' && self.filterForm.code !== null) {
        self.filterForm.code = self.filterForm.code.trim()
      }
      if (self.filterForm.agencyPhone !== '' && self.filterForm.agencyPhone !== null) {
        self.filterForm.agencyPhone = self.filterForm.agencyPhone.trim()
      }
      if (self.filterForm.agencyName !== '' && self.filterForm.agencyName !== null) {
        self.filterForm.agencyName = self.filterForm.agencyName.trim()
      }
      let filterForm = _.cloneDeep(this.filterForm)
      Bus.$emit('order-list-filter', filterForm);
    },
    checkEmptyFilterForm() {
      let isExist = false;
      const isExistKeyword = !!this.filterForm.keyword;
      const isExistMinistryId = !!this.filterForm.ministryIds;
      const isExistUserId = !!this.filterForm.userIds;
      const isExistGroupId = !!this.filterForm.groupId;
      const isExistProductId = !!this.filterForm.productId;
      const isExistPaymentType = !!this.filterForm.paymentType;
      const isExistCreatedAt = _.isArray(this.filterForm.createdAt) ? !!this.filterForm.createdAt.length : false;
      const isExistStatusIds = _.isArray(this.filterForm.statusIds) ? !!this.filterForm.statusIds.length : false;

      isExist = isExistKeyword || isExistMinistryId || isExistUserId || isExistGroupId || isExistProductId || isExistPaymentType || isExistCreatedAt || isExistStatusIds;
      return isExist;
    },
    async exportExcel() {
      // if (!this.checkEmptyFilterForm()) {
      //   this.$swal({
      //   type: 'error',
      //   title: 'Lỗi !',
      //   text: 'Vui lòng chọn ít nhất 1 điều kiện tìm kiếm',
      //   })
      //   return;
      // }
      const loader = this.$loading.show();
      let user = await TokenService.getUser()
      let filterForm = _.cloneDeep(this.filterForm)
      const res = await AgencyRepository.exportExcelOrders({...filterForm, username: user.username})
      loader.hide();
      if (res.data.success) {
        this.$swal({
          text: 'Tải xuống dữ liệu thành công!',
          timer: 1000,
          showConfirmButton: false,
          icon: 'success'
        })
        await downloadFile(_.get(res, 'data.data.csvFile', ''), _.get(res, 'data.data.fileName', ''));
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(res, 'message', '')
        });
      }
    }
  }
};
</script>
